import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, TextField, Typography, Box } from "@mui/material";
import API_BASE_URL from "../../../../../../../Constants";



const CreateAccount = ({ customerId, userId, userName, setFormData, updateList }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleCreateAccount = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/setup/customers/${customerId}/account`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userName: username,
                    password: password,
                }),
            });

            if (!response.ok) {
                const errorMessage = await response.text();
                throw new Error(errorMessage);
            }
            const createdUserName = await response.text();

            setFormData((prevFormData) => ({
                ...prevFormData,
                userName: createdUserName,
            }));
            updateList();
            alert(`Account created successfully for username: ${createdUserName}`);
        } catch (error) {
            alert(`Failed to create account: ${error.message}`);
        }
    };

    return (
        <Box sx={{ padding: 2 }}>
            {userId || userName ? (
                <Box>
                    <Typography variant="h6">User Account</Typography>
                    <Typography variant="body1">
                        Username: <strong>{userName}</strong>
                    </Typography>
                </Box>
            ) : (
                <Box>
                    <Typography variant="h6">Create Account</Typography>
                    <TextField
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            endAdornment: (
                                <Button
                                    onClick={() => setShowPassword(!showPassword)}
                                    size="small"
                                >
                                    {showPassword ? "Hide" : "Show"}
                                </Button>
                            ),
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCreateAccount}
                        sx={{ marginTop: 2 }}
                    >
                        Create Account
                    </Button>
                </Box>
            )}
        </Box>
    );
};

CreateAccount.propTypes = {
    customerId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    userName: PropTypes.string,
};

export default CreateAccount;
